export default __webpack_public_path__ + "static/media/ksivalue_mobile.f803ae64.jpg";